<template>
  <svg
    width="88"
    height="77"
    viewBox="0 0 54 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9927 5.86884H48.5923C51.3537 5.86884 53.5922 8.10741 53.5922 10.8688V27.6674H16.9927V5.86884Z"
      fill="#92CAE9"
    />
    <path d="M0 5C0 2.23858 2.23858 0 5 0H18V15H0V5Z" fill="#92CAE9" />
    <rect y="9.38959" width="53.5922" height="36.6104" rx="5" fill="#7BB6D8" />
    <path d="M18.0383 0L21.4343 5.86884H14.6423L18.0383 0Z" fill="#92CAE9" />
  </svg>
</template>

<script>
export default {
  name: "ClosedFolder"
};
</script>
